import store from '@/store/index'
import config from '@/config';
var that;
var Socket = {
    websocket: "",
    getUntreated: "",
    timer: "",
    client: "",
    tips:"",
    init: function () {
        that = this;
        if (typeof (WebSocket) === "undefined") {
            console.log("您的浏览器不支持socket"); return;
        }
        that.websocket = new WebSocket(config.wsUrl);
        that.websocket.onmessage = this.message;
        that.websocket.onopen = this.open;
        that.websocket.onerror = this.error;
        that.websocket.onclose = this.close;
    },
    sendMsg: function(text){
        that.websocket.send(text)
    },
    open: function () {
        if (that.timer != "") {
            clearInterval(that.timer);
            that.timer = "";
        }
        console.log("连接成功")
        that.client = Math.floor(Math.random() * (99999 - 10000)) + 10000;
        //{ 'type': 2, 'to': '0', 'data':'123', 'client': this.client }
        let login_info = JSON.stringify({ 'type': 1, 'from': store.state.userInfo.user_id, 'client': that.client })
        that.sendMsg(login_info)
    },

    message: function (e) {
        console.log(e.data)
        let json_data = JSON.parse(e.data);
        if (json_data['type'] == 1 && json_data['data'] == "ok") {
            console.log("登录成功")
        } else if (json_data['type'] == 0) {
            console.log(json_data['data'])
        } else if (json_data['type'] == 2) {
            console.log("收到新消息")
            that.tips({
                title: '客户成交通知',
                duration:60,
                desc: json_data['data']
            });
        }
    },


    error: function () {
        console.log("链接失败")
    },

    close: function () {
        console.log("链接断开，5秒钟后尝试重新链接")
        if (that.timer == "") {
            that.timer = setInterval(function () {
                that.init(that.getUntreated);
            }, 5000)
        }
    }
}

export default Socket;
